import React from "react";

/**
 * LabeledBox with floating label (left) and extras (right)
 *
 * Props:
 *  - label        : string
 *  - extras       : React.ReactNode (icon/buttons/etc)
 *  - color        : border + label color
 *  - labelBg      : background for floating label
 *  - fullWidth    : stretch container
 *  - padding      : inside padding
 *  - labelSize    : label font-size
 *  - labelWeight  : label weight
 *  - children     : inner content
 *  - style        : override style
 */

const LabeledBox = ({
  label,
  extras = null,
  color = "#1677ff",
  labelBg = "#fff",
  fullWidth = false,
  padding = 12,
  labelSize = 13,
  labelWeight = 600,
  children,
  style = {},
}) => {
  return (
    <div
      style={{
        position: "relative",
        border: `0.5px solid ${color}`,
        borderRadius: 8,
        padding,
        width: fullWidth ? "100%" : "fit-content",
        background: "#fff",
        ...style,
      }}
    >
      {/* Floating top row: label left, extras right */}
      <div
        style={{
          position: "absolute",
          top: "-14px",
          left: 0,
          width: "100%",
          padding: "0 8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pointerEvents: "none", // allow clicking through
        }}
      >
        {/* Label (left) */}
        <div
          style={{
            backgroundColor: labelBg,
            color,
            fontSize: labelSize,
            fontWeight: labelWeight,
            padding: "0 8px",
            borderRadius: 6,
            lineHeight: "1.4",
            pointerEvents: "auto",
          }}
        >
          {label}
        </div>

        {/* Extras (right) */}
        {extras && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              pointerEvents: "auto",
            }}
          >
            {extras}
          </div>
        )}
      </div>

      {/* Content */}
      <div style={{ marginTop: 4 }}>{children}</div>
    </div>
  );
};

export default LabeledBox;
